export default {

  open (context, account) {
    context.commit('open', account)
  },

  close (context) {
    context.commit('close')
  },

  open_with_tab(context, { tabType, formData, account }) {
    if (account) {
      context.commit('set_account', account)
    }
    context.commit('open_with_tab', { tabType, formData })
  }
}
